import { useLingui } from "@lingui/react";
import NotFoundSVG from "../assets/NotFound.svg";

export const NotFound = ({ className = "" }: { className?: string }) => {
  const { i18n } = useLingui();

  const altText = i18n.t({
    id: "dealer.notFound.altText",
    message: "Not found",
    comment: "Alt text for the not found image",
  });

  return <img className={`max-w-[152px] ${className}`} src={NotFoundSVG} alt={altText} />;
};
